"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var FadeTypeEnum;

(function (FadeTypeEnum) {
  FadeTypeEnum["fadeIn"] = "fadeIn";
  FadeTypeEnum["fadeOut"] = "fadeOut";
})(FadeTypeEnum || (FadeTypeEnum = {}));

var Fade =
/** @class */
function (_super) {
  __extends(Fade, _super);

  function Fade(props) {
    var _this = _super.call(this, props) || this;

    _this.animation = new react_native_1.Animated.Value(0);
    return _this;
  }

  Fade.prototype.componentDidMount = function () {
    this.fadeIn();
  };

  Fade.prototype.fadeIn = function () {
    var _this = this;

    var _a = this.props,
        type = _a.type,
        duration = _a.duration;
    var isFadeOut = type === Fade.type.fadeOut;
    var animationDuration = isFadeOut ? duration / 5 : duration;
    react_native_1.Animated.timing(this.animation, {
      duration: animationDuration,
      toValue: 1,
      useNativeDriver: true
    }).start(function () {
      return setTimeout(function () {
        if (_this.props.type === Fade.type.fadeOut) {
          _this.fadeOut();
        }
      }, animationDuration);
    });
  };

  Fade.prototype.fadeOut = function () {
    this.animation.setValue(1);
    react_native_1.Animated.timing(this.animation, {
      toValue: 0,
      duration: this.props.duration / 5,
      useNativeDriver: true
    }).start();
  };

  Fade.prototype.render = function () {
    var children = this.props.children;
    return react_1.default.createElement(FullWidth, null, react_1.default.createElement(react_native_1.Animated.View, {
      style: {
        opacity: this.animation
      }
    }, children));
  };

  Fade.type = FadeTypeEnum;
  return Fade;
}(react_1.Component);

exports.Fade = Fade;
var FullWidth = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    min-width: 100%;\n"], ["\n    display: flex;\n    width: 100%;\n    min-width: 100%;\n"])));
var templateObject_1;